import { Extent } from 'ol/extent'
import { Project } from '../state'
import { currentExtent, zoomFromExtent } from '../modelling/bounding_box'
import { MAX_TILES } from '../editor/project_editor'

/**
 * Calculate the project extent from project source
 * Normalizes extent coordinates to [minX, minY, maxX, maxY]
 */
export function calculateProjectExtent(projectSource: Project): Extent {
  if (!projectSource.extent) {
    return currentExtent
  }
  
  return [
    Math.min(projectSource.extent[0], projectSource.extent[2]),
    Math.min(projectSource.extent[1], projectSource.extent[3]),
    Math.max(projectSource.extent[0], projectSource.extent[2]),
    Math.max(projectSource.extent[1], projectSource.extent[3])
  ]
}

/**
 * Calculate the zoom level for a project extent
 */
export function calculateProjectZoom(projectExtent: Extent): number {
  return zoomFromExtent(projectExtent, MAX_TILES)
}

/**
 * Calculate the center point of a project extent
 */
export function calculateProjectCenter(projectExtent: Extent): [number, number] {
  return [
    (projectExtent[0] + projectExtent[2]) / 2,
    (projectExtent[1] + projectExtent[3]) / 2
  ]
}

export {
  projectModelToReadable,
  componentsToReadable,
  type ProjectModelReadableOptions,
  type ComponentsReadableOptions,
} from "../editor/project_model_readable"

/**
 * Extract project mask settings from project source
 */
export function extractProjectMaskSettings(projectSource: Project) {
  const mask = projectSource.layer 
    ? projectSource.layer !== "" 
    : (projectSource.shape !== undefined && projectSource.shape !== "")
  
  const maskSource = projectSource.layer ? projectSource.layer : ""
  const maskCQL = projectSource.cql ? projectSource.cql : ""
  
  return { mask, maskSource, maskCQL }
}
